module.exports = __webpack_public_path__ + "static/media/texticon.1980e55a.png";